import * as firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyCDoIApcCMpIRWU7aJmkqAtwHCTtJFkQWQ',
  authDomain: 'scooprinc.firebaseapp.com',
  databaseURL: 'https://scooprinc.firebaseio.com',
  projectId: 'scooprinc',
  storageBucket: 'scooprinc.appspot.com',
  messagingSenderId: '469855566419',
  appId: '1:469855566419:web:4b91576603c8fd81c3e4a6',
  measurementId: 'G-7VDJ6N1D8F'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth
const currentUser = () => { return auth().currentUser }

// firebase collections
const usersCollection = db.collection('users')

// timestamp
const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp

export {
  db,
  auth,
  currentUser,
  usersCollection,
  serverTimestamp,
  firebase
}
